import React from 'react';

export const SessionContext = React.createContext({
	auth: {
		session: null,
		isLoggedIn: false,
		isResetingPassword: false,
		lastAttemptedAt: null,
		lastLoadedAt: null,
		loginError: false,
		resetPasswordError: false,
		resetPasswordSuccess: false,
		twoFactorLogin: false
	},
	// eslint-disable-next-line no-empty-function
	setAuth: () => {
	}
});
